import { $fetch } from '@/boot/fetch'

const ENDPOINT = '/retailers/orderLookup'

export default {
  /**
   * @description Get a retailer's order by order number and customer email address
   * @function orderLookup
   * @param {String} customerEmail
   * @param {String} orderNumber
   * @param {Object} options
   * @param {String} [options.giftGiverEmail] - Email of the gift giver for gift return lookup
   * @returns {Promise}
   */
  async getSingle(customerEmail, orderNumber, { giftGiverEmail = null } = {}) {
    let params = { customerEmail, orderNumber }
    if (giftGiverEmail) {
      params.giftGiverEmail = giftGiverEmail
    }

    try {
      return await $fetch.peg(ENDPOINT, { params })
    } catch (error) {
      // Order-not-found (404) and rate-limit (429) are expected, handled lookup
      // outcomes — not exceptional errors. Return the error payload spread with
      // success:false (carrying message/statusCode); the customer-return flow
      // branches on success/statusCode and treats a missing `retailers` field as
      // an empty list to show the "order not found" copy or the rate-limit
      // message, so preserve that contract here (the API throws by default now).
      // Any other status is a genuine error and is rethrown.
      if (error?.statusCode === 404 || error?.statusCode === 429) {
        return { ...error, success: false }
      }
      throw error
    }
  },
}
